import { getMeetingInsights } from './meetingInsightsSelectors';
import { getMeetingInsightsStore } from '../store/store';
import InsightsDataFetchSource from '../store/schema/InsightsDataFetchSource';

export function getInsightsMeetingIdForDeeplink(): string | null {
    const meetingIdToInsightsMap = getMeetingInsightsStore().meetingIdToInsightsMap;
    if (meetingIdToInsightsMap.size !== 1) {
        // Only support showing one event's insights in deeplink
        return null;
    }
    const meetingId = meetingIdToInsightsMap.keys().next().value;
    const meetingInsights = getMeetingInsights(meetingId);
    if (meetingInsights.dataFetchSource !== InsightsDataFetchSource.Deeplink) {
        // Do not show insights if the meeting insights is not fetched by deeplink
        return null;
    }

    return meetingId;
}
